module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "head_fm",
    attrs: {
      "id": "bill"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9780062300201_Contents#ill"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("LIST OF ILLUSTRATIONS")])])]), _vm._v(" "), _c('div', {
    staticClass: "chap"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/chaptermark2.png"
    }
  }), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("  1."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('a', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter01#unfig001"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Lee Harvey Oswald, posing with his rifle")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("  2."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('a', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter02#unfig001"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("John F. Kennedy, Lyndon B. Johnson, and Martin Luther King Jr.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("  3."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('a', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter02#unfig002"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("President Kennedy in Berlin")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("  4."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('a', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter02#unfig003"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Oswald as a high school student")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("  5."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter03#unfig001",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("President Kennedy, Caroline, and John Jr. in the Oval Office")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("  6."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter04#unfig001",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Oswald’s rifle")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("  7."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter04#unfig002",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Kennedy with Johnson and Governor Connally")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("  8."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter04#unfig003",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Kennedy outside of the Hotel Texas")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("  9."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter04#unfig004",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Kennedy speaking in front of the Hotel Texas")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("10."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter04#unfig005",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Jackie and JFK disembark Air Force One")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("11."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter04#unfig006",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Jackie with roses at Love Field")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("12."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter04#unfig007",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("The Kennedys and Connally in the Dallas motorcade")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("13."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter04#unfig008",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("The presidential motorcade proceeds through Dallas")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("14."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter04#unfig009",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Map of Dealey Plaza")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("15."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter05#unfig001",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Oswald’s view of the limousine")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("16."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter05#unfig002",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Zapruder’s camera")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("17."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter05#unfig003",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Side and rear view of bullet")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("18."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter05#unfig004",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Kennedy’s second wound")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("19."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter05#unfig005",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("The sixth-floor Texas Book Depository window")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("20."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter06#unfig001",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("The presidential limousine at Parkland Hospital")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("21."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter07#unfig001",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Carrying the casket aboard Air Force One")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("22."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter07#unfig002",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Lyndon Johnson being sworn in")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("23."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter08#unfig001",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("The president’s casket at the U.S. Capitol")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("24."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter09#unfig001",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("The funeral procession at the United States Capitol")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("25."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter09#unfig002",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Jacqueline Kennedy and children at the Capitol")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("26."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter09#unfig003",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("The procession to St. Matthew’s Cathedral")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("27."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter09#unfig004",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("The caisson leaves for St. Matthew’s")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("28."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter09#unfig005",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Carrying the casket to the grave site")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("29."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter09#unfig006",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Panoramic view of the funeral at Arlington")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("30."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter09#unfig007",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Folding the national colors")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("31."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter09#unfig008",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("The Lee mansion at Arlington Cemetery")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("32."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter09#unfig009",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Mourning buttons")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("33."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter09#unfig010",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Memorial banner")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("34."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter09#unfig011",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Memorial banner")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("35."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter09#unfig012",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Dealey Plaza desk set")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("36."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter09#unfig013",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("The electric Eternal Flame night-light")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("37."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter09#unfig014",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Jackie tribute magazine")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("38."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter09#unfig015",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Oswald magazine")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_vm._v("39."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter10#unfig001",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("The Warren Commission presents its Report to President Johnson")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dd73dac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9780062300201_Illustrations.vue
// module id = 72
// module chunks = 0